import { getTableMetaHelper } from '@round/ui-kit';
import { UnallocatedCampaignsData } from './useUnallocatedCampaigns';
import { creatorbase } from '@round/api';

export type UnallocatedCampaignsRow = UnallocatedCampaignsData;

export type Meta = {
    isLoading: boolean;
    isRefetching: boolean;
    getIsBrandLoading?: (row: UnallocatedCampaignsRow) => boolean;
    getIsProjectLoading?: (row: UnallocatedCampaignsRow) => boolean;
    getArePurchaseOrdersLoading?: (row: UnallocatedCampaignsRow) => boolean;
    onAllocate: (row: UnallocatedCampaignsRow) => void;
    onUpdated: (row?: creatorbase.Campaign) => void;
};

export const getTableMeta = getTableMetaHelper<Meta>();
